import { useState, useEffect, useMemo } from 'react';
import { getContext } from '@/context';

export const GENAI_STUDIO_TOUCHPOINT = 'com.picsart.apps.genai';

const POLL_INTERVAL_MS = 150;
const MAX_ATTEMPTS = 10;

const readTouchpoint = (): string | null => {
  try {
    const headers = getContext().utils.api.getHeaders();
    return headers?.['x-touchpoint-referrer'] ?? null;
  } catch {
    return null;
  }
};

const isWebGenaiStudio =
  typeof window !== 'undefined' &&
  window.location.href.toLowerCase().includes('genaistudio');

export const useTouchpoint = () => {
  const [touchpoint, setTouchpoint] = useState<string | null>(readTouchpoint);

  useEffect(() => {
    if (touchpoint !== null) return;

    let attempt = 0;
    const id = setInterval(() => {
      const value = readTouchpoint();
      attempt += 1;
      if (value !== null || attempt >= MAX_ATTEMPTS) {
        setTouchpoint(value);
        clearInterval(id);
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- only poll on mount when initial read returned null

  return useMemo(() => {
    const isGenaiStudioTouchpoint = touchpoint === GENAI_STUDIO_TOUCHPOINT;
    return {
      touchpoint,
      isGenaiStudioTouchpoint,
      isWebGenaiStudio,
      showUserMenu: isGenaiStudioTouchpoint || isWebGenaiStudio,
    };
  }, [touchpoint]);
};
